import { useEffect, useState } from 'react';

import UniversalHeader from '../../../UniversalHeader/UniversalHeader';
import LoadingComponent from '../../LoadingComponent/LoadingComponent';

import { useSession } from 'next-auth/react'
import { useRouter } from 'next/router';
import Head from 'next/head';

const Layout = ({ children }) => {

  const router = useRouter();

  const { data: session, status } = useSession();

  // If user is authenticated, check if they're banned
  useEffect(() => {
    if(session && status === 'authenticated') {
      const username = session.user.token.username;
      const userID = session.user.token.id;

      async function verifyAccount() {
        
      }


    }
  }, [session, status])

  const [loading, setLoading] = useState(true);
  const [routeLoading, setRouteLoading] = useState(false);

  useEffect(() => {
    if (status === 'loading') return setLoading(true);
    if (routeLoading) return setLoading(true);

    setLoading(false);
  }, [status, routeLoading]);


  function handleStart(url) {
    // Check if the path is actually changing
    if (router.asPath.split('?')[0] !== url.split('?')[0]) {
      setRouteLoading(true);
    }
  }

  function handleComplete(urlObj) {
    // Extract the href from the url object
    const href = urlObj && typeof urlObj === 'object' && urlObj.href ? urlObj.href : '';
    // Check if the path is actually changing
    if (router.asPath.split('?')[0] !== href.split('?')[0]) {
      setRouteLoading(false);
    }
  }

  useEffect(() => {

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, [router]);

  return (
    <div style={{width: '100%', height: '100%', position: 'relative', overflow: 'hidden'}}>
        <Head>
          <meta charSet="utf-8" />
          <meta property="og:image" content="/v10-icons-OG/ogImage.png" />
          <link rel="apple-touch-icon" sizes="180x180" href="/v10-icons/apple-touch-icon.png?v=10" />
          <link rel="icon" type="image/png" sizes="32x32" href="/v10-icons/favicon-32x32.png?v=10" />
          <link rel="icon" type="image/png" sizes="16x16" href="/v10-icons/favicon-16x16.png?v=10" />
          <link rel="manifest" href="/v10-icons/site.webmanifest?v=10" />
          <link rel="mask-icon" href="/v10-icons/safari-pinned-tab.svg?v=10" color="#154734" />
          <link rel="shortcut icon" href="/v10-icons/favicon.ico?v=10" />
          <meta name="msapplication-TileColor" content="#da532c" />
          <meta name="msapplication-TileImage" content="/v10-icons/mstile-144x144.png?v=10" />
          <meta name="msapplication-config" content="/v10-icons/browserconfig.xml?v=10" />
          <meta name="theme-color" content="#154734" />

          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
        </Head>

      <main style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden'}}>
        <UniversalHeader />
        { loading ? <LoadingComponent /> : children }
      </main>

    </div>
  );
};

export default Layout;